import { useEffect } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const dark = theme === "dark";
  const action = `Switch to ${dark ? "light" : "dark"} theme`;
  useEffect(() => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#050505" : "#fafafa");
  }, [dark]);
  return (
    <Button type="button" data-testid="theme-toggle-btn" data-current-theme={dark ? "dark" : "light"}
      variant="outline" onClick={() => setTheme(dark ? "light" : "dark")} aria-label={action} title={action}
      className="h-10 w-10 shrink-0 rounded-full border-surface-700 bg-surface-950 p-0 text-copy-300 hover:bg-surface-800 hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring motion-safe:hover:rotate-12 transition-[color,background-color,transform]">
      {dark ? <Moon aria-hidden="true" size={17} /> : <Sun aria-hidden="true" size={17} />}
    </Button>
  );
}
